import { RootState } from "reducers/rootReducer";
import { Config } from "./type";

export const selectConfig = (state: RootState): Config[] => state.config.configs;

export const selectError = (state: RootState): string | undefined | null => state.config.error;

export const selectIsLoading = (state: RootState): boolean => state.config.isLoading;
